export const shippingOptions = [
  {
    id: 7,
    name: "CMA",
    showName:"CMA",
  },
  {
    id: 8,
    showName:"CNC",
    name: "CNC"
  },

  {
    id: 10,
    showName:"COSCO",
    name: "COSCO"
  },

  {
    id: 15,
    showName:"EMC",
    name: "EMC"
  },

  {
    id: 24,
    showName:"HPL",
    name: "HPL"
  },

  // {
  //   id: 29,
  //   name: "SEALAND"
  // },

  {
    id: 32,
    showName:"MSC",
    name: "MSC"
  },

  {
    id: 33,
    showName:"MSK",
    name: "MSK"
  },

  {
    id: 42,
    showName:"OOCL",
    name: "OOCL"
  },

  {
    id: 148,
    showName:"ONE",
    name: "ONE"
  }
];

export const containerTypeOptions = [
  {
    id: "20GP",
    name: "20GP",
  },
  {
    id: "40GP",
    name: "40GP"
  },
  {
    id: "40HQ",
    name: "40HQ"
  }
];
